export default __webpack_public_path__ + "static/open-8af9c1f70d8dc1f3e60de1489556575c.png";